import React from "react";
import styled from "styled-components/macro";
import Speech from "components/speech/Speech";
import { useViewerDecks } from "queries/viewerQuery";
import { AssistantMode } from "./__generated__/AssistantMutation.graphql";

const SSpeech = styled(Speech)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  button {
    color: ${(p) => p.theme.duo.color.lightBlue};
    margin: auto;
    opacity: 1;
    width: 40px;
    height: 40px;
  }
  svg {
    width: 20px;
    height: 20px;
  }
`;

type Props = {
  text: string;
  playOnMount?: boolean;
  textLangs?: string[];
  zeroVolumeGuard?: boolean;
  onClick?: VoidFunction;
  onEnded?: VoidFunction;
  assistantMode?: AssistantMode;
};

const TTSButton: React.FC<Props> = ({
  text,
  playOnMount,
  textLangs,
  zeroVolumeGuard,
  onEnded,
  onClick,
  assistantMode
}) => {
  const { deck } = useViewerDecks();

  return (
    <SSpeech
      onEnded={onEnded}
      text={text}
      lang={deck!.front}
      useServerCache={false}
      playOnMount={playOnMount}
      zeroVolumeGuard={zeroVolumeGuard}
      onClick={onClick}
      ttsQueryOptions={{
        multiLangs: textLangs,
        assistantMode
      }}
    />
  );
};

export default TTSButton;
